import React from "react";
import "./skills.css";

const skills = [
  {
    name: "HTML",
    color: "#E44D26",
    svg: (
      <svg viewBox="0 0 128 128">
        <path
          fill="#E44D26"
          d="M19.037 113.876L9.032 1.661h109.936l-10.016 112.198-45.019 12.48z"
        />
        <path fill="#F16529" d="M64 116.8l36.378-10.086 8.559-95.878H64z" />
        <path
          fill="#EBEBEB"
          d="M64 52.455H45.788L44.53 38.361H64V24.599H29.489l.33 3.692 3.382 37.927H64zm0 35.743l-.061.017-15.327-4.14-.979-10.975H33.816l1.928 21.609 28.193 7.826.063-.017z"
        />
        <path
          fill="#fff"
          d="M63.952 52.455v13.763h16.947l-1.597 17.849-15.35 4.143v14.319l28.215-7.82.207-2.325 3.234-36.233.335-3.696h-3.708zm0-27.856v13.762h33.244l.276-3.092.628-6.978.329-3.692z"
        />
      </svg>
    ),
  },
  {
    name: "CSS",
    color: "#1572B6",
    svg: (
      <svg viewBox="0 0 128 128">
        <path
          fill="#1572B6"
          d="M18.814 114.123L8.76 1.352h110.48l-10.064 112.754-45.243 12.543-45.119-12.526z"
        ></path>
        <path
          fill="#33A9DC"
          d="M64.001 117.062l36.559-10.136 8.601-96.354h-45.16v106.49z"
        ></path>
        <path
          fill="#fff"
          d="M64.001 51.429h18.302l1.264-14.163H64.001V23.435h34.682l-.332 3.711-3.4 38.114h-30.95V51.429z"
        ></path>
        <path
          fill="#EBEBEB"
          d="M64.083 87.349l-.061.018-15.403-4.159-.985-11.031H33.752l1.937 21.717 28.331 7.863.063-.018v-14.39z"
        ></path>
        <path
          fill="#fff"
          d="M81.127 64.675l-1.666 18.522-15.426 4.164v14.39l28.354-7.858.208-2.337 2.406-26.881H81.127z"
        ></path>
        <path
          fill="#EBEBEB"
          d="M64.048 23.435v13.831H30.64l-.277-3.108-.63-7.012-.331-3.711h34.646zm-.047 27.996v13.831H48.792l-.277-3.108-.631-7.012-.33-3.711h16.447z"
        ></path>
      </svg>
    ),
  },
  {
    name: "JavaScript",
    color: "#F7DF1E",
    svg: (
      <svg viewBox="0 0 128 128">
        <path fill="#F0DB4F" d="M1.408 1.408h125.184v125.185H1.408z"></path>
        <path
          fill="#323330"
          d="M116.347 96.736c-.917-5.711-4.641-10.508-15.672-14.981-3.832-1.761-8.104-3.022-9.377-5.926-.452-1.69-.512-2.642-.226-3.665.821-3.32 4.784-4.355 7.925-3.403 2.023.678 3.938 2.237 5.093 4.724 5.402-3.498 5.391-3.475 9.163-5.879-1.381-2.141-2.118-3.129-3.022-4.045-3.249-3.629-7.676-5.498-14.756-5.355l-3.688.477c-3.534.893-6.902 2.748-8.877 5.235-5.926 6.724-4.236 18.492 2.975 23.335 7.104 5.332 17.54 6.545 18.873 11.531 1.297 6.104-4.486 8.08-10.234 7.378-4.236-.881-6.592-3.034-9.139-6.949-4.688 2.713-4.688 2.713-9.508 5.485 1.143 2.499 2.344 3.63 4.26 5.795 9.068 9.198 31.76 8.746 35.83-5.176.165-.478 1.261-3.666.38-8.581zM69.462 58.943H57.753l-.048 30.272c0 6.438.333 12.34-.714 14.149-1.713 3.558-6.152 3.117-8.175 2.427-2.059-1.012-3.106-2.451-4.319-4.485-.333-.584-.583-1.036-.667-1.071l-9.52 5.83c1.583 3.249 3.915 6.069 6.902 7.901 4.462 2.678 10.459 3.499 16.731 2.059 4.082-1.189 7.604-3.652 9.448-7.401 2.666-4.915 2.094-10.864 2.07-17.444.06-10.735.001-21.468.001-32.237z"
        ></path>
      </svg>
    ),
  },
  {
    name: "React",
    color: "#61DAFB",
    svg: (
      <svg viewBox="0 0 128 128">
        <circle cx="64" cy="64" r="11" fill="#61DAFB" />
        <g fill="none" stroke="#61DAFB" strokeWidth="6">
          <ellipse rx="56" ry="24" cx="64" cy="64" />
          <ellipse
            rx="56"
            ry="24"
            cx="64"
            cy="64"
            transform="rotate(60 64 64)"
          />
          <ellipse
            rx="56"
            ry="24"
            cx="64"
            cy="64"
            transform="rotate(120 64 64)"
          />
        </g>
      </svg>
    ),
  },
  {
    name: "Bootstrap",
    color: "#7952B3",
    svg: (
      <svg viewBox="0 0 128 128">
        <defs>
          <linearGradient
            id="a"
            x1="76.079"
            x2="523.48"
            y1="10.798"
            y2="365.95"
            gradientTransform="translate(1.11 14.613) scale(.24566)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#9013fe"></stop>
            <stop offset="1" stop-color="#6610f2"></stop>
          </linearGradient>
          <linearGradient
            id="b"
            x1="193.51"
            x2="293.51"
            y1="109.74"
            y2="278.87"
            gradientTransform="translate(0 52)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#fff"></stop>
            <stop offset="1" stop-color="#f1e5fc"></stop>
          </linearGradient>
          <filter
            id="c"
            width="197"
            height="249"
            x="161.9"
            y="135.46"
            color-interpolation-filters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dy="4"></feOffset>
            <feGaussianBlur stdDeviation="8"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"></feColorMatrix>
            <feBlend
              in2="BackgroundImageFix"
              result="effect1_dropShadow"
            ></feBlend>
            <feBlend
              in="SourceGraphic"
              in2="effect1_dropShadow"
              result="shape"
            ></feBlend>
          </filter>
        </defs>
        <path
          fill="url(#a)"
          d="M14.985 27.712c-.237-6.815 5.072-13.099 12.249-13.099h73.54c7.177 0 12.486 6.284 12.249 13.099-.228 6.546.068 15.026 2.202 21.94 2.141 6.936 5.751 11.319 11.664 11.883v6.387c-5.913.564-9.523 4.947-11.664 11.883-2.134 6.914-2.43 15.394-2.202 21.94.237 6.815-5.072 13.098-12.249 13.098h-73.54c-7.177 0-12.486-6.284-12.249-13.098.228-6.546-.068-15.026-2.203-21.94-2.14-6.935-5.76-11.319-11.673-11.883v-6.387c5.913-.563 9.533-4.947 11.673-11.883 2.135-6.914 2.43-15.394 2.203-21.94z"
        ></path>
        <path
          fill="url(#b)"
          d="M267.1 364.46c47.297 0 75.798-23.158 75.798-61.355 0-28.873-20.336-49.776-50.532-53.085v-1.203c22.185-3.609 39.594-24.211 39.594-47.219 0-32.783-25.882-54.138-65.322-54.138h-88.74v217zm-54.692-189.48h45.911c24.958 0 39.131 11.128 39.131 31.279 0 21.505-16.484 33.535-46.372 33.535h-38.67zm0 161.96v-71.431h45.602c32.661 0 49.608 12.03 49.608 35.49 0 23.459-16.484 35.941-47.605 35.941z"
          filter="url(#c)"
          transform="translate(1.494 2.203) scale(.24566)"
        ></path>
      </svg>
    ),
  },
  {
    name: "MongoDB",
    color: "#47A248",
    svg: (
      <svg viewBox="0 0 128 128">
        <path
          fill="#47A248"
          d="M64 0s36 28 36 64-36 64-36 64S28 100 28 64 64 0 64 0z"
        />
      </svg>
    ),
  },
  {
    name: "GitHub",
    color: "#181717",
    svg: (
      <svg viewBox="0 0 128 128">
        <path
          fill="#ffffffff"
          d="M64 0C28.654 0 0 28.654 0 64c0 28.205 18.293 52.076 43.693 60.5 3.2.592 4.368-1.392 4.368-3.088v-10.896c-17.76 3.856-21.504-8.56-21.504-8.56-2.912-7.392-7.104-9.376-7.104-9.376-5.808-3.968.448-3.888.448-3.888 6.432.448 9.824 6.592 9.824 6.592 5.712 9.776 14.976 6.944 18.624 5.312.576-4.128 2.24-6.944 4.096-8.544-14.176-1.6-29.056-7.104-29.056-31.616 0-6.976 2.496-12.672 6.576-17.152-.656-1.6-2.848-8.064.624-16.832 0 0 5.36-1.712 17.568 6.56 5.088-1.408 10.56-2.112 16-2.136 5.44.024 10.912.728 16 2.136 12.192-8.272 17.536-6.56 17.536-6.56 3.488 8.768 1.264 15.232.624 16.832 4.096 4.48 6.576 10.176 6.576 17.152 0 24.576-14.912 30-29.088 31.584 2.304 1.984 4.352 5.888 4.352 11.888v17.6c0 1.696 1.152 3.696 4.384 3.072C109.712 116.08 128 92.205 128 64c0-35.346-28.654-64-64-64z"
        />
      </svg>
    ),
  },
  {
    name: "Figma",
    color: "#F24E1E",
    svg: (
      <svg viewBox="0 0 128 128">
        <circle cx="32" cy="32" r="16" fill="#F24E1E" />
        <circle cx="32" cy="64" r="16" fill="#A259FF" />
        <circle cx="32" cy="96" r="16" fill="#1ABCFE" />
        <circle cx="64" cy="32" r="16" fill="#0ACF83" />
        <circle cx="64" cy="64" r="16" fill="#F24E1E" />
      </svg>
    ),
  },
  {
    name: "Tailwind CSS",
    color: "#38B2AC",
    svg: (
      <svg viewBox="0 0 128 128">
        <path
          fill="#38bdf8"
          d="M13.227 56.074c-3.528 0-5.727 1.778-6.602 5.301 1.324-1.773 2.875-2.426 4.625-1.977 1 .25 1.727.977 2.523 1.801 1.301 1.324 2.801 2.852 6.079 2.852 3.523 0 5.722-1.778 6.597-5.301-1.324 1.773-2.875 2.426-4.625 1.977-1-.25-1.722-.977-2.523-1.801-1.301-1.324-2.801-2.852-6.074-2.852zM6.602 64C3.074 64 .875 65.773 0 69.3c1.324-1.777 2.875-2.425 4.625-1.976 1 .25 1.727.977 2.523 1.801 1.301 1.324 2.801 2.852 6.079 2.852 3.523 0 5.722-1.778 6.597-5.301-1.324 1.773-2.875 2.426-4.625 1.972-1-.25-1.722-.972-2.523-1.796C11.398 65.523 9.898 64 6.602 64zm0 0"
        ></path>
        <path
          fill="#fff"
          d="M39.676 62.75h-2.301v4.477c0 1.199.773 1.171 2.3 1.097v1.801c-3.1.375-4.323-.477-4.323-2.898V62.75h-1.704v-1.926h1.704v-2.5l2-.597v3.097h2.296v1.926zm8.8-1.926h2v9.301h-2v-1.352c-.703.977-1.8 1.579-3.25 1.579-2.527 0-4.624-2.153-4.624-4.903 0-2.773 2.097-4.898 4.625-4.898 1.449 0 2.546.597 3.25 1.574zm-2.953 7.625c1.676 0 2.954-1.25 2.954-2.972 0-1.727-1.278-2.977-2.954-2.977-1.671 0-2.949 1.25-2.949 2.977.028 1.722 1.278 2.972 2.95 2.972zm8.301-9.023c-.699 0-1.273-.602-1.273-1.278 0-.699.574-1.273 1.273-1.273.7 0 1.278.574 1.278 1.273.023.676-.579 1.278-1.278 1.278zm-1 10.699v-9.3h2v9.3zm4.324 0V56.551h2v13.574zm15.079-9.3h2.125l-2.926 9.3h-1.977l-1.926-6.273-1.949 6.273h-1.972l-2.926-9.3H62.8l1.8 6.425 1.95-6.426h1.926l1.921 6.426zm4.597-1.4c-.699 0-1.273-.6-1.273-1.277 0-.699.574-1.273 1.273-1.273.7 0 1.278.574 1.278 1.273.023.676-.551 1.278-1.278 1.278zm-1 10.7v-9.3h2v9.3zm9.227-9.55c2.074 0 3.574 1.425 3.574 3.823v5.727h-2v-5.5c0-1.426-.824-2.148-2.074-2.148-1.324 0-2.375.773-2.375 2.671v5h-2v-9.296h2v1.199c.625-1 1.625-1.477 2.875-1.477zm13.125-3.473h2v13.023h-2v-1.352c-.7.977-1.801 1.579-3.25 1.579-2.528 0-4.625-2.153-4.625-4.903 0-2.773 2.097-4.898 4.625-4.898 1.449 0 2.55.597 3.25 1.574zm-2.95 11.347c1.672 0 2.95-1.25 2.95-2.972 0-1.727-1.278-2.977-2.95-2.977-1.675 0-2.953 1.25-2.953 2.977 0 1.722 1.278 2.972 2.954 2.972zm11.672 1.926c-2.796 0-4.921-2.148-4.921-4.898 0-2.778 2.097-4.903 4.921-4.903 1.829 0 3.403.95 4.153 2.403l-1.727 1c-.398-.875-1.324-1.426-2.449-1.426-1.648 0-2.875 1.25-2.875 2.926 0 1.671 1.25 2.921 2.875 2.921 1.125 0 2.023-.574 2.477-1.421l1.722.972c-.75 1.477-2.347 2.426-4.176 2.426zm7.528-7c0 1.7 5 .676 5 4.125 0 1.852-1.625 2.875-3.625 2.875-1.852 0-3.2-.852-3.801-2.176l1.727-1c.296.852 1.046 1.352 2.074 1.352.898 0 1.574-.301 1.574-1.051 0-1.648-5-.727-5-4.05 0-1.75 1.5-2.848 3.398-2.848 1.528 0 2.801.699 3.454 1.921l-1.704.954c-.324-.727-.972-1.051-1.75-1.051-.722-.028-1.347.3-1.347.949zm8.574 0c0 1.7 5 .676 5 4.125 0 1.852-1.625 2.875-3.625 2.875-1.852 0-3.2-.852-3.8-2.176l1.726-1c.3.852 1.05 1.352 2.074 1.352.898 0 1.574-.301 1.574-1.051 0-1.648-5-.727-5-4.05 0-1.75 1.5-2.848 3.403-2.848 1.523 0 2.796.699 3.449 1.921l-1.7.954c-.328-.727-.976-1.051-1.75-1.051-.726-.028-1.351.3-1.351.949zm0 0"
        ></path>
      </svg>
    ),
  },
  {
    name: "React Native",
    color: "#61DAFB",
    svg: (
      <svg viewBox="0 0 128 128">
        <path
          fill="#61dafb"
          d="M87.043 0c-6.49 0-14.985 4.626-23.574 12.649C54.879 4.673 46.385.094 39.896.094v.023c-1.982 0-3.776.426-5.334 1.323-6.63 3.822-8.116 15.739-4.695 30.699-14.677 4.53-24.234 11.775-24.234 19.42 0 7.67 9.604 14.936 24.328 19.442-3.398 15.008-1.887 26.947 4.768 30.77 1.533.896 3.326 1.322 5.308 1.322 6.49 0 14.985-4.626 23.574-12.648C72.201 98.42 80.695 103 87.184 103c1.98 0 3.774-.425 5.332-1.322 6.63-3.823 8.117-15.74 4.695-30.7 14.63-4.506 24.187-11.773 24.187-19.42 0-7.667-9.603-14.935-24.328-19.442 3.398-15.007 1.887-26.946-4.767-30.769C90.776.453 88.99.029 87.043.026Zm-.025 5.264v.021c1.085 0 1.96.213 2.69.614 3.21 1.84 4.602 8.85 3.517 17.863-.26 2.218-.684 4.554-1.204 6.937-4.625-1.132-9.675-2.005-14.984-2.572-3.185-4.365-6.49-8.33-9.816-11.8C74.901 9.192 82.11 5.279 87.018 5.265Zm-47.122.092c4.885 0 12.128 3.893 19.82 10.996a111.464 111.464 0 0 0-9.745 11.775c-5.333.567-10.38 1.44-15.006 2.596a71.207 71.207 0 0 1-1.229-6.844c-1.108-9.014.26-16.02 3.446-17.885.707-.424 1.63-.613 2.714-.613Zm23.55 14.7a97.245 97.245 0 0 1 6.56 7.552 146.124 146.124 0 0 0-6.49-.164c-2.219 0-4.412.046-6.559.164a92.142 92.142 0 0 1 6.488-7.551zm.07 12.673c3.563 0 7.127.166 10.619.449a129.947 129.947 0 0 1 5.71 8.967 122.88 122.88 0 0 1 4.909 9.39 132.039 132.039 0 0 1-4.885 9.414c-1.84 3.185-3.73 6.207-5.687 9.015-3.517.307-7.08.47-10.666.47-3.564 0-7.126-.163-10.618-.446a129.968 129.968 0 0 1-5.71-8.966 123.017 123.017 0 0 1-4.909-9.393 122.827 122.827 0 0 1 4.885-9.414c1.84-3.185 3.727-6.206 5.686-9.014a122.779 122.779 0 0 1 10.666-.472zm-17.534 1.226c-1.156 1.817-2.31 3.68-3.396 5.592a134.016 134.016 0 0 0-3.068 5.664 101.03 101.03 0 0 1-3.256-9.39c3.09-.732 6.346-1.37 9.72-1.866zm35.02 0c3.35.496 6.582 1.11 9.674 1.866-.874 3.044-1.96 6.18-3.186 9.32a111.667 111.667 0 0 0-3.092-5.664c-1.085-1.888-2.24-3.728-3.396-5.522Zm14.77 3.258a74.843 74.843 0 0 1 6.632 2.406c8.353 3.563 13.756 8.235 13.756 11.94-.024 3.705-5.428 8.4-13.781 11.94-2.03.872-4.246 1.652-6.535 2.383-1.345-4.624-3.116-9.44-5.31-14.37 2.17-4.908 3.916-9.697 5.237-14.3zm-64.608.024c1.345 4.624 3.116 9.437 5.31 14.369-2.17 4.908-3.917 9.699-5.238 14.3a71.77 71.77 0 0 1-6.607-2.408c-8.353-3.563-13.758-8.234-13.758-11.94 0-3.704 5.405-8.4 13.758-11.94 2.03-.872 4.246-1.65 6.535-2.381zm32.328 3.539c-5.955 0-10.783 4.827-10.783 10.783 0 5.956 4.828 10.783 10.783 10.783 5.956 0 10.783-4.827 10.783-10.783 0-5.956-4.827-10.783-10.783-10.783zM87.49 57.883a101.21 101.21 0 0 1 3.256 9.39 105.882 105.882 0 0 1-9.72 1.89 130.649 130.649 0 0 0 3.396-5.594 133.785 133.785 0 0 0 3.068-5.686zm-47.972.094a112.03 112.03 0 0 0 3.091 5.664 156.557 156.557 0 0 0 3.4 5.52c-3.35-.495-6.586-1.11-9.677-1.865.873-3.044 1.96-6.181 3.186-9.32zm52.55 14.393c.543 2.384.967 4.673 1.227 6.868 1.108 9.013-.26 16.02-3.445 17.884-.708.425-1.627.616-2.713.616-4.885 0-12.13-3.894-19.823-10.997a111.433 111.433 0 0 0 9.747-11.775c5.332-.566 10.383-1.44 15.007-2.596zm-57.056.047c4.625 1.133 9.673 2.006 14.982 2.572 3.185 4.366 6.49 8.33 9.817 11.8-7.693 7.15-14.913 11.066-19.82 11.066-1.062-.024-1.959-.236-2.667-.637-3.209-1.84-4.6-8.849-3.515-17.863.26-2.218.683-4.554 1.203-6.938zm21.992 3.092c2.124.094 4.294.164 6.488.164 2.218 0 4.413-.046 6.56-.164a92.152 92.152 0 0 1-6.49 7.55c-2.194-2.265-4.387-4.79-6.558-7.55zm42.39 36.918c-.374 0-.66.11-.853.324-.187.215-.281.48-.281.791 0 .313.094.571.28.78.195.207.48.312.855.312s.659-.105.853-.312a1.1 1.1 0 0 0 .29-.78c0-.312-.096-.576-.29-.79-.194-.216-.48-.325-.853-.325zm-94.072.21v15.153H7.33v-6.13h3.56l3.29 6.13h2.144v-.125l-3.56-6.431c.91-.347 1.616-.872 2.123-1.573.513-.7.77-1.522.77-2.466 0-1.485-.46-2.616-1.384-3.393-.915-.777-2.228-1.166-3.935-1.166zm59.463 0v15.153h2.01v-11.677l7.629 11.677h2.01v-15.153h-1.99v11.73l-7.649-11.73zm-11.875 1.165v2.727h-2.05v1.488h2.05v6.984c0 .958.218 1.697.654 2.217.438.52 1.088.781 1.948.781.48 0 .972-.07 1.478-.209v-1.56c-.388.083-.694.125-.916.125-.45 0-.77-.112-.957-.334-.187-.23-.28-.569-.28-1.02v-6.984h2.1v-1.488h-2.1v-2.727zm39.053 0v2.727h-2.051v1.488h2.05v6.984c0 .958.22 1.697.656 2.217.438.52 1.085.781 1.945.781.48 0 .972-.07 1.479-.209v-1.56c-.39.083-.694.125-.916.125-.451 0-.77-.112-.957-.334-.187-.23-.281-.569-.281-1.02v-6.984h2.1v-1.488h-2.1v-2.727zm-84.633.48h3.06c1.055.005 1.86.26 2.415.76.562.498.843 1.216.843 2.153 0 .86-.295 1.547-.884 2.06-.583.514-1.37.772-2.364.772H7.33Zm15.27 2.038c-.896 0-1.728.25-2.498.75-.764.492-1.36 1.18-1.79 2.062-.425.874-.636 1.87-.636 2.986v.354c0 1.679.48 3.021 1.437 4.027.958 1 2.2 1.5 3.727 1.5 1.887 0 3.302-.726 4.246-2.176l-1.176-.916a4.345 4.345 0 0 1-1.24 1.104c-.472.278-1.047.416-1.727.416-.957 0-1.748-.34-2.373-1.02-.617-.687-.94-1.584-.968-2.695h7.628v-.803c0-1.797-.404-3.178-1.216-4.142-.812-.965-1.95-1.447-3.414-1.447zm11.252 0a5.5 5.5 0 0 0-2.258.46c-.68.304-1.223.72-1.625 1.247-.395.52-.594 1.063-.594 1.625h1.937c0-.493.233-.913.698-1.26.465-.347 1.04-.52 1.726-.52.784 0 1.38.201 1.782.604.402.395.603.928.603 1.601v.885h-1.875c-1.617 0-2.873.326-3.768.979-.888.645-1.332 1.556-1.332 2.728 0 .965.355 1.761 1.063 2.393.715.625 1.626.937 2.736.937 1.242 0 2.312-.465 3.207-1.394.07.57.16.963.27 1.185h2.02v-.166c-.264-.61-.395-1.432-.395-2.467v-5.183c-.028-1.138-.41-2.029-1.147-2.674-.735-.653-1.75-.98-3.048-.98zm11.718 0c-1.026 0-1.917.236-2.674.71-.75.47-1.325 1.133-1.728 1.987-.403.853-.604 1.827-.604 2.924v.322c0 1.777.452 3.18 1.354 4.207.91 1.02 2.13 1.53 3.664 1.53.764 0 1.484-.175 2.164-.522a4.373 4.373 0 0 0 1.645-1.395c.41-.583.633-1.196.668-1.842h-1.823c-.055.625-.34 1.145-.853 1.561a2.774 2.774 0 0 1-1.8.625c-.993 0-1.757-.35-2.292-1.05-.534-.701-.8-1.701-.8-2.999v-.363c0-1.332.266-2.35.8-3.05.541-.709 1.301-1.06 2.28-1.06.728 0 1.34.234 1.831.706.5.464.78 1.062.834 1.79h1.823c-.056-1.207-.505-2.189-1.344-2.945-.833-.756-1.882-1.136-3.145-1.136zm38.492 0a5.5 5.5 0 0 0-2.257.46c-.68.304-1.223.72-1.625 1.247-.396.52-.592 1.063-.592 1.625h1.935c0-.493.233-.913.698-1.26.465-.347 1.04-.52 1.726-.52.784 0 1.38.201 1.782.604.402.395.603.928.603 1.601v.885h-1.873c-1.617 0-2.875.326-3.77.979-.888.645-1.332 1.556-1.332 2.728 0 .965.355 1.761 1.063 2.393.714.625 1.626.937 2.736.937 1.242 0 2.312-.465 3.207-1.394.07.57.158.963.27 1.185h2.02v-.166c-.264-.61-.395-1.432-.395-2.467v-5.183c-.028-1.138-.411-2.029-1.147-2.674-.735-.653-1.751-.98-3.05-.98zm33.985 0a4.5 4.5 0 0 0-2.498.75c-.764.492-1.361 1.18-1.791 2.062-.423.874-.635 1.87-.635 2.986v.354c0 1.679.48 3.021 1.438 4.027.957 1 2.198 1.5 3.724 1.5 1.888 0 3.304-.726 4.248-2.176l-1.176-.916a4.351 4.351 0 0 1-1.24 1.104c-.472.278-1.046.416-1.726.416-.958 0-1.75-.34-2.373-1.02-.618-.687-.941-1.584-.97-2.695h7.63v-.803c0-1.797-.406-3.178-1.217-4.142-.812-.965-1.95-1.447-3.414-1.447zm-19.631.21v11.26h1.926v-11.26zm3.904 0 4.078 11.26h1.47l4.038-11.26h-1.97l-2.788 8.649-2.86-8.65zm-79.72 1.374c.804 0 1.443.27 1.916.81.471.535.735 1.291.79 2.27v.146h-5.642c.125-1.02.451-1.812.98-2.375a2.56 2.56 0 0 1 1.956-.85zm95.447 0c.805 0 1.442.27 1.914.81.472.535.736 1.291.79 2.27v.146h-5.64c.125-1.02.45-1.812.979-2.375a2.56 2.56 0 0 1 1.957-.85zm-83.436 4.423h1.51v2.31c-.243.5-.635.905-1.176 1.218a3.389 3.389 0 0 1-1.718.468c-.632 0-1.149-.17-1.55-.51-.403-.34-.605-.812-.605-1.415 0-1.381 1.18-2.07 3.54-2.07zm50.21 0h1.51v2.31c-.242.5-.634.905-1.175 1.218a3.389 3.389 0 0 1-1.72.468c-.63 0-1.147-.17-1.55-.51-.401-.34-.603-.812-.603-1.415 0-1.381 1.18-2.07 3.54-2.07z"
        ></path>
      </svg>
    ),
  },

  {
    name: "VS Code",
    color: "#007ACC",
    svg: (
      <svg viewBox="0 0 128 128">
        <path
          fill="#0065A9"
          d="M123.471 13.82 97.097 1.12A7.973 7.973 0 0 0 88 2.668L1.662 81.387a5.333 5.333 0 0 0 .006 7.887l7.052 6.411a5.333 5.333 0 0 0 6.811.303l103.971-78.875c3.488-2.646 8.498-.158 8.498 4.22v-.306a8.001 8.001 0 0 0-4.529-7.208Z"
        />
        <path
          fill="#007ACC"
          d="m123.471 114.181-26.374 12.698A7.973 7.973 0 0 1 88 125.333L1.662 46.613a5.333 5.333 0 0 1 .006-7.887l7.052-6.411a5.333 5.333 0 0 1 6.811-.303l103.971 78.874c3.488 2.647 8.498.159 8.498-4.219v.306a8.001 8.001 0 0 1-4.529 7.208Z"
        />
        <path
          fill="#1F9CF0"
          d="M97.098 126.882A7.977 7.977 0 0 1 88 125.333c2.952 2.952 8 .861 8-3.314V5.98c0-4.175-5.048-6.266-8-3.313a7.977 7.977 0 0 1 9.098-1.549L123.467 13.8A8 8 0 0 1 128 21.01v85.982a8 8 0 0 1-4.533 7.21l-26.369 12.681Z"
        />
      </svg>
    ),
  },
];

const experiences = [
  {
    year: "Dec 2024 - June 2026",
    role: "Graphic Designer",
    company: "Aceels Adornment Pvt. Ltd. | Remote",
  },
  {
    year: "Feb 2024 - May 2024",
    role: "Web Developer intern",
    company: "Corevo Private Limited | Remote",
  },
];

const Skills = () => {
  return (
    <section className="skills">
      <h2>Skills and Experience</h2>

      <div className="skills-experience-wrapper">
        {/* ===== LEFT: SKILLS (YOUR DESIGN) ===== */}
        <div className="skills-grid">
          {skills.map((skill, index) => (
            <div className="skill-card" key={index}>
              <div className="skill-icon" style={{ color: skill.color }}>
                {skill.svg}
              </div>
              <p>{skill.name}</p>
            </div>
          ))}
        </div>

        {/* ===== RIGHT: EXPERIENCE ===== */}
        <div className="experience">
          {experiences.map((exp, index) => (
            <div className="experience-item" key={index}>
              <span className="experience-year">{exp.year}</span>
              <div className="experience-details">
                <h4>{exp.role}</h4>
                <p>{exp.company}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
